const defaultState = {
  deliveries: [],
  deliveriesLoadError: false,
  enterprises: [],
  enterprise: null,
  catalogProductTypes: [],
}

export default function (state = defaultState, action) {
  switch (action.type) {
    case "ENTERPRISES_LOADED":
      return { ...state, enterprises: action.enterprises }
    case "ENTERPRISE_CREATED":
      return { ...state, enterprises: [...state.enterprises, action.enterprise] }
    case "ENTERPRISE_LOADED":
      return { ...state, enterprise: action.enterprise }
    case "AVAILABLE_DCS_LOADED":
      return { ...state, availableDCs: action.availableDCs }
    case "ENTERPRISE_DCS_UPDATED":
      return { ...state, enterprise: action.enterprise }
    case "ENTERPRISE_CONTACTS_UPDATED":
      return { ...state, enterprise: action.enterprise }
    case "DELIVERIES_LOADED":
      return { ...state, deliveries: action.deliveries, deliveriesLoadError: false }
    case "DELIVERIES_LOAD_FAILED":
      return { ...state, deliveriesLoadError: true }
    case "DELIVERIES_CREATED":
      return { ...state, deliveries: [...action.deliveries, ...state.deliveries] }
    case "ENTERPRISE_UPDATED":
      return { ...state, enterprise: action.enterprise }
    case "CATALOG_PRODUCT_TYPES_LOADED":
      return { ...state, catalogProductTypes: action.catalogProductTypes }
    case "WEEKLY_MENUS_LOADED":
      return { ...state, weeklyMenus: action.weeklyMenus }
    case "WEEKLY_MENU_CREATED":
      return { ...state, weeklyMenus: [action.weeklyMenu, ...state.weeklyMenus] }
    default:
      return { ...state }
  }
}

export const getOrganizationsWeeklyMenusSelector = (state) => state.organizations.weeklyMenus
export const getOrganizationsEnterprisesSelector = (state) => state.organizations.enterprises
export const getOrganizationsEnterpriseSelector = (state) => state.organizations.enterprise
export const getAvailableDCsSelector = (state) => state.organizations.availableDCs
export const getOrganizationsDeliveriesSelector = (state) => state.organizations.deliveries
export const getDeliveriesLoadErrorSelector = (state) => state.organizations.deliveriesLoadError
export const getCatalogProductTypesSelector = (state) => state.organizations.catalogProductTypes
